import { Directive, ElementRef, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../services/config/config.service';
import { WrapperHttpService } from './../../store/services/wrapper-http-service';

@Directive({ selector: '[imageId]' })
export class ImageLoadDirective {
  @Input()
  set imageId(imageId: string) {
    if (imageId) {
      this.setImageSrc(imageId);
    }
  }

  private readonly picturePath = '/picture';

  constructor(private elementRef: ElementRef, private http: WrapperHttpService) {}

  private setImageSrc(imageId: string): void {
    setTimeout(() => {
      this.getImage$(imageId).subscribe((image: string) => {
        this.elementRef.nativeElement.src = image;
      });
    });
  }

  private getImage$(imageId: string): Observable<string> {
    return this.http.get(`${API_URL}${this.picturePath}?id=${imageId}`, {
      responseType: 'text',
    });
  }
}
